export default __webpack_public_path__ + "static/media/archana-tanawade.b122a360.png";